import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { RequestUtilsService } from "./requestUtils";
import { GetHttpHeadersSimple } from "./serviceUtils";
import { mapMessageCenters } from "./requestMapperUtils";
import type { MessageCenter } from "../interfaces/messageCenter.interface";

@Injectable({
    providedIn: "root"
})
export class MessageCenterService {
    constructor(private requestUtils: RequestUtilsService) {}

    getAllActiveMessages(businessArea?: string | number): Observable<MessageCenter[]> {
        const url = `svk_messagecenters?$select=createdon,svk_activefrom,svk_activeto,svk_messagecenterid,svk_message,svk_name,statuscode,_createdby_value,statecode,svk_publishonweb,svk_priority,_svk_businessarea_value,svk_showasnewcasemessage&$filter=(statecode eq 0 and statuscode eq 922520000 and svk_publishonweb eq true${businessArea ? " and _svk_businessarea_value eq " + businessArea + " and svk_showasnewcasemessage eq true" : ""} )&$orderby=svk_name asc`;
        return this.requestUtils.createGetRequest<MessageCenter[]>(url, mapMessageCenters, GetHttpHeadersSimple).pipe(
            map((messages) => {
                return messages.filter((message) => {
                    if (message.activeFrom && message.activeTo) {
                        // Timezone conversion
                        const currentDate = new Date();
                        const activeFrom = new Date(message.activeFrom);
                        const activeTo = new Date(message.activeTo);

                        return activeFrom && activeTo && activeFrom <= currentDate && activeTo >= currentDate;
                    }
                    return;
                });
            })
        );
    }

    getAllMessages(): Observable<MessageCenter[]> {
        const url = `svk_messagecenters?$select=createdon,svk_activefrom,svk_activeto,svk_messagecenterid,svk_message,svk_name,statuscode,_createdby_value,statecode,svk_publishonweb,svk_priority,_svk_businessarea_value,svk_showasnewcasemessage&$filter=(statecode eq 0 and statuscode eq 922520000 and svk_publishonweb eq true)&$orderby=svk_activefrom desc`;
        return this.requestUtils.createGetRequest<MessageCenter[]>(url, mapMessageCenters, GetHttpHeadersSimple);
    }
}
